module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Tamara-Lim-93a98179d72a32385b58d3a00e22d11a.jpg";